<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M20.464 6.677a1 1 0 00-1.88-.685l-7.047 19.333a1 1 0 001.88.685l7.047-19.333zm-10.742 4.29a1 1 0 01-.13 1.409l-4.36 3.625 4.36 3.625a1 1 0 11-1.279 1.538L3.028 16.77a1 1 0 010-1.538l5.285-4.394a1 1 0 011.409.13zm12.557 0a1 1 0 011.408-.129l5.286 4.394a1 1 0 010 1.538l-5.286 4.394a1 1 0 01-1.278-1.538L26.769 16l-4.36-3.625a1 1 0 01-.13-1.408z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemCode'
}
</script>
